/* global BMS */

export const VC2_ENDPOINT = (channel) => `ws://172.17.0.44/player/ws?cust=ingg&channel=${channel}&X-Atmosphere-tracking-id=0&X-Atmosphere-Framework=2.3.2-javascript&X-Atmosphere-Transport=websocket&X-Atmosphere-TrackMessageSize=true&Content-Type=application/json&X-atmo-protocol=true`;
export const VC2_VIDEO_ENDPOINT = (channel) => `http://172.17.0.44/inggWebViewer/?cust=ingg&channel=${channel}`;

export const ASSETS_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? './assets/' // to use remote assets, create the ssh tunnel and use e.g. http://localhost:4000/assets/
    : BMS.assetsUrl + ((BMS.theme !== '') ? (BMS.theme + '/') : '');

export const HELP_PAGES_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? './helpPages/' // to use remote assets, create the ssh tunnel and use e.g. http://localhost:4000/assets/
    : BMS.helpPagesUrl;

export const ADVERTS_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? 'http://plugnplay-l1.inseincvirtuals.com/adverts/advert1.html' // just for debug
    : BMS.advertsUrl;

export const CLIENT_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? './'
    : BMS.clientBaseUrl;

export const PROMO_ASSETS_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? './assets/' // to use remote assets, create the ssh tunnel and use e.g. http://localhost:4000/assets/
    : BMS.operatorConfig.promoAssetsUrl;



// WEBPACK FOOTER //
// ./src/constants/endpoints.js